<template>
  <validation-observer v-slot="{ handleSubmit, reset }">
    <form @submit.prevent="handleSubmit(submitForm)" @reset.prevent="reset" class="main_form step2form hunter_3_columns">
        <div class="coverings_bloc_1 bloc_narrow gdpr simple" v-for="item in data.CT_PACKAGES" :key="item.PACKAGE_ID">
          <label class="radio-button-field w-radio">
              <div :class="['w-form-formradioinput w-form-formradioinput--inputType-custom radio-button-2 simple w-radio-input', item.ZZSELECTED_IND ? 'w--redirected-checked' : '']"></div>
              <input type="radio" data-name="Radio 4" id="radio-4" name="radio" v-model="selectedPackage" :value="item.PACKAGE_ID" style="opacity:0;position:absolute;z-index:-1" @change="selectPackage(item)">
              <span class="paragraph-3 left w-form-label">{{item.PACKAGE_DESC}}</span>
            </label>
        </div>
      <button type="submit" id="w-node-_7143e79d-3470-f95c-b9b4-c693e46cb25e-333689bf" class="submit-button submit-button-2 main_button w-button" :disabled=isSelectedPackage>{{ $t('SUBMIT') }}</button>
    </form>
  </validation-observer>
</template>

<script>
export default {
  data() {
    return {
      selectedPackage: ''
    };
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    isSelectedPackage() {
      return !(this.data.CT_PACKAGES.filter((o) => o.ZZSELECTED_IND).length);
    }
  },
  methods: {
    selectPackage(item) {
      this.$emit('select-package', item);
    },
    submitForm() {
      // console.log(this.$store.state);
      this.$emit('next');
      console.log('submitted');
    }
  }
};
</script>
